import { send } from '../../../../src/network/network';
import { type PaginatedProductCategoryList } from '../../../../src/types/PaginatedProductCategoryList';

type Params = {
  limit?: number;
  offset?: number;
};

export async function getApiV2ProductCategories(params: Params) {
  const queryParams = new URLSearchParams();

  if (params.limit !== undefined) {
    queryParams.append('limit', params.limit.toString());
  }

  if (params.offset !== undefined) {
    queryParams.append('offset', params.offset.toString());
  }

  return await send<PaginatedProductCategoryList>({
    path: '/api/v2/product_categories/',
    method: 'GET',
    query: queryParams,
  });
}
